export default "__VITE_ASSET__BFObEED7__"